import { urlConfig } from "../../config/urlConfig";
import {
  PreworkSummaryListDetailchild,
  PreworkSummaryModel,
} from "../../types/PreworksummaryModel";
import { postCall } from "../httpService";

export const GetPreworkSummaryData = async (params: PreworkSummaryModel) => {
  try {
    const response = await postCall(urlConfig.PreworkSummaryGetData, params);
    return response.data;
  } catch (error) {
    console.error("Error in Prework summary data fetching ", error);
    throw error;
  }
};

export const GetInstruction = async (params: PreworkSummaryListDetailchild) => {
  try {
    const response = await postCall(urlConfig.GetInstructions, params);
    return response.data;
  } catch (error) {
    console.error("Error in GetInstruction data fetching ", error);
    throw error;
  }
};
